export default "__VITE_ASSET__BBDjcORC__"